<template>
    <a-date-picker
            :value="dateValue"
            allowClear
            :placeholder="placeholder"
            valueFormat="YYYY-MM-DD"
            @change="onChange"/>
</template>

<script>
    export default {
        props:{
            dateValue:{
                type:String,
                default:''
            },
            placeholder:{
                type:String,
                default:''
            }
        },
        methods:{
            onChange(date, dateString){
                this.$emit('update:dateValue',dateString)
            }
        }
    }
</script>

<style scoped>

</style>
